import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className"];
import React, { forwardRef, useContext } from 'react';
import { useComponentTheme } from '../../../utils/hooks';
import { AccordionContentRoot } from './style';
import { accordionContentDefaultTheme } from './theme';
import { ACCORDION_CONTENT_CLASS_PREFIX, accordionContent } from '../constants';
import AccordionContext from '../AccordionContext';
import useAccordionContentClassName from './useAccordionContentClassName';
export var AccordionContent = forwardRef(function AccordionContent(_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(ACCORDION_CONTENT_CLASS_PREFIX, accordionContentDefaultTheme);

  var _useContext = useContext(AccordionContext),
      disabled = _useContext.disabled,
      isExpanded = _useContext.isExpanded;

  var classOverride = useAccordionContentClassName(ACCORDION_CONTENT_CLASS_PREFIX, className, disabled, isExpanded);
  return React.createElement(AccordionContentRoot, Object.assign({
    "data-testid": accordionContent
  }, restProps, {
    className: classOverride.Content,
    disabled: disabled,
    isExpanded: isExpanded,
    ref: ref,
    theme: theme
  }), children);
});